import { FetcherWithComponents } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useEffect } from "react";

function fetcherCompleted(fetcher: FetcherWithComponents<any>): boolean {
  return fetcher.state === "idle" && fetcher.data && !fetcher.data.error;
}

function fetcherErrored(fetcher: FetcherWithComponents<any>): boolean {
  return fetcher.state === "idle" && fetcher.data && fetcher.data.error;
}

export function useDecoratedFetcher(fetcher: FetcherWithComponents<any>): {
  completed: boolean;
  errored: boolean;
} {
  const completed = fetcherCompleted(fetcher);
  const errored = fetcherErrored(fetcher);

  return { completed, errored };
}

export function useFetcherWithSnackbar(
  fetcher: FetcherWithComponents<any>,
  successMessage: string,
  errorMessage: string
): {
  completed: boolean;
  errored: boolean;
} {
  const { completed, errored } = useDecoratedFetcher(fetcher);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (completed) {
      enqueueSnackbar(successMessage, { variant: "success" });
    }
  }, [completed]);

  useEffect(() => {
    if (errored) {
      enqueueSnackbar(errorMessage, { variant: "error" });
    }
  }, [errored]);

  return { completed, errored };
}
